<template>
    <div class="showMarkdownArea">
        <mavon-editor class="md" :value="value" :subfield="false" defaultOpen='preview' placeholder="" :editable="false" :toolbarsFlag="false" :ishljs="true"  :previewBackground="previewStyle" :codeStyle="mavonCodestyle"></mavon-editor>
    </div>
</template>
<script>
import {mavonEditor} from 'mavon-editor';
import 'mavon-editor/dist/css/index.css'
import 'highlight.js/styles/atelier-lakeside-dark.css';
import 'highlight.js/styles/github.css';
export default{
    props:{
        value:{},

    },
    data(){
        return{
            previewStyle : this.themeVal == 'black' ? 'transparent' : 'transparent',//'#f8f8f8',
            mavonCodestyle : this.themeVal == 'black' ? 'atelier-lakeside-dark' :  'github',//'default',
        }
    },
    created(){

    },

    components:{mavonEditor},
    methods:{

    },
    watch:{

    }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/common/questionStem.scss';
</style>

<style lang="scss">
    body{
        .showMarkdownArea{
            .markdown-body .highlight pre, .markdown-body pre{
                font-size: 100% !important;
            }
            .markdown-body code{
                font-size: 100% !important;
            }
            .markdown-body blockquote, .markdown-body dl, .markdown-body ol, .markdown-body p, .markdown-body pre, .markdown-body table, .markdown-body ul{
                margin-bottom: 6px;
            }
            .markdown-body h1,h2   {
                padding-bottom: .3em !important;
                // font-size: 1.3em !important;
                border-bottom: 0!important;
            }
            .markdown-body hr {
                transform: scaleY(0.3) !important;
                border-bottom-color: #eaecef;
            }
        }


    }
    html[data-theme="black"]{
        .showMarkdownArea{
            .markdown-body .highlight pre, .markdown-body pre{
                background-color: transparent !important;
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/markdown/markdownShow.vue